import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontDocuments from './documents';
import waiter from '../img/wait.svg'
import FrontFooter from './footer'
import download from '../img/file-download-line.png'
import FrontProgress from './progress';
import api from '../apiConnector'
import FileUploader from './fileUploader';

const nameSanitize = (str) => {
    if ( str == 'fma_signed' ) {
        str = '✓ Vos documents signés'
    }
    if (str.startsWith("tosign_")) {
        str = str.slice(7)+' (à signer)'; 
    }
    return str
}

const isDownloadableDoc = (name) => {
    return !name.startsWith('uploaded_')
}

const Document = ({doc,devis}) => <a className="document_download" href={api.downloadDocument(devis.typedId(),doc.name)} target="_blank">{nameSanitize(doc.name)}</a>

const DocumentUploader = ({piece,devis,onUploaded})=>{
    const {code,valide,libelle} = piece
    const docName = 'uploaded_'+code+'.pdf'
    const hasBeenUploaded = devis.documents.some( doc => doc.name == docName )
    return <div className="uploader"><div className="head_decorator">🗎</div><div className="libelle">
        {libelle}
        {hasBeenUploaded&&(!valide)&&<><hr/>✅ Reçu</>}
        {(!hasBeenUploaded)&&<><hr/>❌ Non reçu</>}
        {valide&&<><br/>✅ Validé</>}
        {hasBeenUploaded&&<> | <a href={api.downloadDocument(devis.typedId(),docName)} target="_blank">Visualiser</a></>}
    </div>
    {valide ? <div className="tail_decorator"></div> : <div className="tail_decorator">
        <FileUploader devis={devis} code={code} onUploaded={onUploaded} title={hasBeenUploaded?'Envoyer à nouveau':'Envoyer'}/>
    </div>}
    </div>
}

export default class FrontPaidSubscribedFma extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            infos:false,
            launched_signing:false,
            signing_url:false
        }
    }

    periodic() {
        const {signed_upload} = this.props.devis.fma
        console.log(signed_upload)
        if ( signed_upload == 'ONGOING' ) {
            this.props.checkStatus({'fma.signed_upload':signed_upload})
        }
    }

    componentDidMount() {
        const devis = this.props.devis
        api.post(
            {action:'get_info_fma',
            id:devis.type+devis._id.$oid},
            (res)=>{
                console.log(res.info)
                this.setState({infos:res.info})
            }
        )
        this.timer = setInterval(
            this.periodic.bind(this),
            3000
        )
    }

    componentWillUnmount() {
        if ( this.timer ) {
            clearInterval( this.timer )
            this.timer = false
        }
    }



    signOnline() {
        const devis = this.props.devis
        this.setState({launched_signing:true})
        api.post(
            {action:'generate_sign_url',
            id:devis.type+devis._id.$oid},
            (res)=>{
                this.setState({signing_url:res.signing_url})
            }
        )
    }

    renderEmpty() {
        const {devis} = this.props
        const {fma} = devis
        const {numero_police} = fma
        return <>
            <h1>Votre contrat a été souscrit avec succès</h1>
            <br/>
            <label>Votre numéro de police d'assurance <span>{numero_police}</span></label>
            <img src={waiter} className="waiter semi_transparent"/>
        </>
    }

    renderInfo() {
        const {devis,updateDevis} = this.props
        const {fma} = devis
        const {numero_police} = fma

        const signedUpload = fma.signed_upload
        const doneSignedUpload = signedUpload == 'DONE'
        const errorSignedUpload = signedUpload?.startsWith('ERROR/') ? signedUpload.substring(6) : null
        if ( errorSignedUpload ) console.log(errorSignedUpload)

        return <>
            <h1>Votre contrat a été souscrit avec succès</h1>
            <br/>
            <label>Votre numéro de police d'assurance <span>{numero_police}</span></label>

            <label className="section">Documents à télécharger</label>

            { devis.documents.filter( doc=>isDownloadableDoc(doc.name) ).map( doc => <Document doc={doc} devis={devis} key={doc.name}/> ) }
            
            <br/>
            {errorSignedUpload && <p className="error">Une erreur est survenue lors de la récupération des documents signés</p> }
            {doneSignedUpload ? <a className="button done" href={api.downloadDocument(devis.typedId(),'fma_signed')} target="_blank">✓ Vous avez signé avec succès vos documents</a>
            : this.state.launched_signing?<>
                <label>Signez vos documents en ligne</label>
                {this.state.signing_url ? <><iframe src={this.state.signing_url}/></> : <img src={waiter} className="waiter semi_transparent"/> }
            </>:<>
                <a className="button button_subscribe" onClick={()=>this.signOnline()}>Signez en ligne vos documents</a>
            </>}
            <br/>
            <label className="section">Documents à nous fournir au format PDF</label>

            { this.state.infos.piecesNonSignables.map( piece => <DocumentUploader key={piece.code} piece={piece} devis={devis} onUploaded={
                (res)=>{
                    this.setState({infos:res.info})
                    updateDevis(res.devis)
                }
            }/>)}
            <br/>
            { /* this.state.infos.tokenConnexionURL && <a className="button button_subscribe" href={this.state.infos.tokenConnexionURL} target="_blank">Télécharger votre certificat d'assurance</a> */}

            {/* <textarea style={{width:'100%',height:'20rem'}} value={JSON.stringify(this.state.infos,null,2)} readOnly={true}/> */}
        </>
    }

    render() {
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        return <>
        <FrontProgress lastBranch={this.props.lastBranch || this.props.devis.tb} comparateursCompleted={true} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container">

            <div className="contentbox front_form">
                <div className="contentvbox">
                    {this.state.infos?.tokenConnexionURL ? this.renderInfo():this.renderEmpty()}
                </div>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif devis={this.props.devis} container={container}/>

                <h1 className="subscribe">Contactez nous par téléphone</h1>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>
            </div>

            </div>
            <FrontFooter/>

        </>
    }
}